export const isExternalLink = (url: any) => {
  const rgx = /https?:\/\/((?:[\w\d-]+\.)+[\w\d]{2,})/i;
  return rgx.test(url);
};
